import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import Image from 'next/image';
import styled, { keyframes } from 'styled-components';

const Third = () => {
  return (
    <CMSection>
      <Wrap>
        <ImageWrap>
          <ThirdImage
            width={1920}
            height={613}
            src={'/imgs/sponser/third.svg'}
            alt="image"
          />
          <ThirdMbImage
            width={1920}
            height={613}
            src={'/imgs/sponser/third-mb.svg'}
            alt="image"
          />
          <BigText>
            혈액은 어떠한 과학 기술로도
            <br />
            <span>대체 할 수 없습니다.</span>
          </BigText>
          <SmallText>
            혈액은 현재 대체할 물질이 없고 장기 보관도 어렵습니다.
            <br />
            발전된 과학 기술로도 대체 불가능한 혈액의 공급이 지속적으로 필요한
            상황입니다.
          </SmallText>
        </ImageWrap>
        <TextWrap margin={'0px 0 0px 0'}></TextWrap>
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  @media ${devices.tablet} {
    /* padding: 50px 24px; */
  }
`;

const ImageWrap = styled.div<{ height?: string }>`
  position: relative;
  height: ${({ height }) => height};
`;

const ThirdImage = styled(Image)`
  display: block;

  @media ${devices.tablet} {
    display: none;
  }
`;
const ThirdMbImage = styled(Image)`
  display: none;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const TextWrap = styled.div<{ margin: string }>`
  margin: ${({ margin }) => margin};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BigText = styled.div`
  position: absolute;
  top: 36%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  > span {
    color: ${({ theme }) => theme.commonColor.pink003};
  }
  @media ${devices.tablet} {
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
    width: 80%;
  }
`;

const SmallText = styled.div`
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  white-space: pre-wrap;
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;

  @media ${devices.tablet} {
    font-size: 14px;
    line-height: 24px; /* 150% */
    width: 80%;
    top: 67%;
  }
`;

export default Third;
